import { render, staticRenderFns } from "./service.vue?vue&type=template&id=589e4607&scoped=true"
import script from "./service.vue?vue&type=script&lang=js"
export * from "./service.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589e4607",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('589e4607')) {
      api.createRecord('589e4607', component.options)
    } else {
      api.reload('589e4607', component.options)
    }
    module.hot.accept("./service.vue?vue&type=template&id=589e4607&scoped=true", function () {
      api.rerender('589e4607', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/reservation/service.vue"
export default component.exports